import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PageHeader({ title, subtitle, actions }) {
    return (_jsxs("div", { style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "20px 24px 14px",
            gap: 16,
        }, children: [_jsxs("div", { style: { display: "flex", flexDirection: "column", gap: 2, minWidth: 0 }, children: [_jsx("h1", { style: { fontSize: 22, fontWeight: 600, letterSpacing: "-0.01em", margin: 0 }, children: title }), subtitle && (_jsx("p", { style: { fontSize: 13, color: "var(--ink-2)", margin: 0 }, children: subtitle }))] }), actions && _jsx("div", { style: { display: "flex", alignItems: "center", gap: 8 }, children: actions })] }));
}
//# sourceMappingURL=PageHeader.js.map